import axios from "axios";

const BASE = process.env.VUE_APP_GEOLOCATION_API;

export function geocodeAddress(query) {
  return axios.get(`${BASE}/${encodeURIComponent(query)}`, {
    params: { json: 1 },
  });
}
